<template>
  <div class="row px-0">
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-warning`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد کل کاربران
              </p>
              <h4 class="text-white mb-0">{{ record.player_apps_count }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-user-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-success`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد کاربران فعال
              </p>
              <h4 class="text-white mb-0">{{ record.active_players_count }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-user-follow-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">رشد ماهانه</p>
              <h4
                class=" mb-0"
                :class="{
                  'text-danger': record.growth < 0,
                  'text-success': record.growth > 0,
                }"
              >
                {{ record.growth }} %
              </h4>
            </div>
            <div class="">
              <i
                v-if="record.growth > 0"
                class="font-size-24 text-success ri-line-chart-line"
              ></i>
              <i
                v-if="record.growth < 0"
                class="font-size-24 text-danger ri-line-chart-line"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-warning`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد کل لیگ ها
              </p>
              <h4 class="text-white mb-0">{{ record.leagues_count }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-gamepad-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg bg-success`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate text-white font-size-14 mb-2">
                تعداد لیگ های فعال
              </p>
              <h4 class="text-white mb-0">{{ record.inProcessLeagues }}</h4>
            </div>
            <div class="text-white">
              <i class="font-size-24 ri-gamepad-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div :class="`card-body rounded-lg`">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">درآمد کل</p>
              <h4 class=" mb-0">
                {{ $helper.formatPrice(record.income) }} تومان
              </h4>
            </div>
            <div class="">
              <i class="font-size-24 ri-exchange-dollar-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
}
</script>
